<div class="project-docs-upload">
    <label class="btn btn-outline-primary btn-sm rounded-0 mb-3 cursor-pointer">
        <i class="la la-upload mr-1"></i>
        {{ 'UploadDocument' | localize }}
        <input type="file" class="d-none" multiple (change)="onFilesSelected($event)"
               accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.png,.jpg,.jpeg,.gif,.txt,.zip,.csv" />
    </label>
    <div *ngIf="!selectedFiles.length" class="text-muted font-12 mb-2">
        {{ 'NoProjectDocuments' | localize }}
    </div>
    <div *ngFor="let file of selectedFiles; let i = index" class="d-flex align-items-center bg-white border rounded p-2 mb-2">
        <img [src]="file.icon" alt="" class="mr-2" height="28" width="28" />
        <div class="flex-grow-1 overflow-hidden">
            <div class="font-12 font-weight-bold text-truncate" [title]="file.fileName">{{ file.fileName }}</div>
            <div class="font-12 text-muted">{{ formatSize(file.fileSize) }}</div>
        </div>
        <button type="button" class="border-0 bg-transparent text-danger cursor-pointer" (click)="removeFile(i)">
            <i class="la la-times font-weight-bold"></i>
        </button>
    </div>
</div>
